import React from 'react';

import styled from 'styled-components';

import { CommunityContract } from 'types/contracts';
import { groupAndSortCommunityContracts } from 'utils/data/communities';

const Container = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

interface Props {
  contractType: CommunityContract[];
  dataTestId?: string;
}

const CMASummaryTableDataContractType = ({ contractType, dataTestId }: Props) => {
  const sortedGroups = groupAndSortCommunityContracts(contractType || []);
  const formatPercentages = (values: number[]) => values.map((v) => `${v}%`).join(', ');

  return (
    <Container data-test-id={dataTestId}>
      {sortedGroups.map((group) => (
        <div key={group.name}>
          {group.type === 1 ? group.name : `${group.name} (${formatPercentages(group.percentages)})`}
        </div>
      ))}
    </Container>
  );
};
export default CMASummaryTableDataContractType;
